var map = {
	"./HTML5.svg": "370f",
	"./chat.svg": "22b2",
	"./copy-right.svg": "a40d",
	"./dashboard.svg": "f782",
	"./dragger.svg": "dca7",
	"./editor.svg": "8dba",
	"./excel.svg": "6599",
	"./form.svg": "eb1b",
	"./hamburger.svg": "bd6a",
	"./index.svg": "abb8",
	"./list.svg": "3289",
	"./menu.svg": "bd3d",
	"./message.svg": "47ff",
	"./result-page.svg": "f773",
	"./screenfull.svg": "ace8",
	"./search.svg": "8e8d",
	"./sub-menu.svg": "93c8",
	"./system.svg": "30a9",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";